import React from 'react';

import { Container } from './styles';

type PropTypes = {
  columnWidth?: string;
};

const getGridTemplate = (maxWidth: string): string => `repeat(auto-fill, minmax(${maxWidth}, 1fr))`;

const Grid: React.FC<PropTypes> = ({ children, columnWidth = '200px' }) => (
  <Container style={{ gridTemplateColumns: getGridTemplate(columnWidth) }}>{children}</Container>
);

export default Grid;
